import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { getRewardsAccounts } from "../../../rewards/reducer";
import {
  getIsCreditCardPaymentRequired,
  getRewardsPaymentAccountReferenceId,
  getRewardsPaymentInFiatCurrency,
  getRewardsPaymentInRewardsCurrency,
  rewardsAccountMinimumRequirementStateSelector,
  getTotalCreditCardPaymentRequiredNumber,
  getPaymentTotalInPrices,
  getOfferToApply,
  getCreditToApply,
  getUserSelectedRewardsManually,
  getSelectedRewardsAccountReferenceIds,
  getSelectedRewardsAccounts,
  getIsMultiRewardsBalanceFullyCovered,
  getRewardsAllocations,
} from "../../reducer/selectors";
import { IStoreState } from "../../../../reducers/types";
import { RewardsSelection } from "./component";
import { actions } from "../../actions";

const mapStateToProps = (state: IStoreState) => ({
  rewardsAccounts: getRewardsAccounts(state),
  selectedRewardsPaymentAccountId: getRewardsPaymentAccountReferenceId(state),
  rewardsPaymentInFiatCurrency: getRewardsPaymentInFiatCurrency(state),
  rewardsPaymentInRewardsCurrency: getRewardsPaymentInRewardsCurrency(state),
  isCreditCardPaymentRequired: getIsCreditCardPaymentRequired(state),
  rewardsAccountMinimumRequirementState:
    rewardsAccountMinimumRequirementStateSelector(state),
  totalCreditCardPaymentRequired:
    getTotalCreditCardPaymentRequiredNumber(state),
  total: getPaymentTotalInPrices(state),
  offerToApply: getOfferToApply(state),
  creditToApply: getCreditToApply(state),
  userSelectedRewardsManually: getUserSelectedRewardsManually(state),
  selectedRewardsAccountReferenceIds:
    getSelectedRewardsAccountReferenceIds(state),
  selectedRewardsAccounts: getSelectedRewardsAccounts(state),
  isMultiRewardsBalanceFullyCovered:
    getIsMultiRewardsBalanceFullyCovered(state),
  rewardsAllocations: getRewardsAllocations(state),
});

const mapDispatchToProps = {
  setSelectedRewardsAccountId: actions.setSelectedRewardsAccountReferenceId,
  setRewardsPaymentAmount: actions.setSelectedRewardsPaymentTotal,
  setRewardsAccountCustomAmount: actions.setSelectedRewardsAccountCustomAmount,
  fetchProductToEarn: actions.fetchProductToEarn,
  setRewardsConversionFailed: actions.setRewardsConversionFailed,
  setPaymentMethod: actions.setPaymentMethod,
  setEarnValue: actions.setEarnValue,
  setQuotedRewardsTotal: actions.setQuotedRewardsTotal,
  setUserSelectedRewardsManually: actions.setUserSelectedRewardsManually,
  toggleRewardsAccount: actions.toggleSelectedRewardsAccount,
  clearSelectedRewardsAccounts: actions.clearSelectedRewardsAccounts,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type RewardsSelectionConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedRewardsSelection = withRouter(
  connector(RewardsSelection)
);
